var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 16.36h15.235v2.2H0zm15.235-9.816-7.617 7.618L0 6.544h4.346V0h6.544v6.544z"
})));
export default SvgIconDownload;